import * as R from 'ramda';
import { combineReducers } from 'redux';
import { ORGANISATION_INITIALISE, ORGANISATION_ADD_NETWORKS } from '../../organisation/actions';
import { NETWORK_INITIALISE, NETWORK_UPDATE_NETWORK } from '../../network/actions';
import {
  UPDATE_NETWORK_BY_ID_SUCCESS,
  IMPORT_COMMUNITY_SUCCESS,
  IMPORT_COMMUNITIES_BULK_SUCCESS,
} from '../../admin/actions/integration-communities';

const storeById = (acc, network) => R.assoc(network.id, {
  ...acc[network.id],
  ...R.omit(['membership'], network),
}, acc);

export const formatNetworks = (networks, state = {}) => {
  return R.reduce(storeById, state, networks);
};

const items = (state = {}, action) => {
  switch (action.type) {
    case NETWORK_INITIALISE:
    case NETWORK_UPDATE_NETWORK:
      return storeById(state, action.network);
    case ORGANISATION_INITIALISE:
      return formatNetworks(action.networks);
    case ORGANISATION_ADD_NETWORKS:
      return R.reduce(storeById, state, action.items);
    case UPDATE_NETWORK_BY_ID_SUCCESS:
    case IMPORT_COMMUNITY_SUCCESS:
      return storeById(state, action.data);
    case IMPORT_COMMUNITIES_BULK_SUCCESS:
      return Array.isArray(action.data)
        ? R.reduce(storeById, state, action.data)
        : state;
    case 'admin/DELETE_NETWORK':
      return R.omit([action.id], state);
    default: return state;
  }
};

export const findById = R.curry((state, id) => {
  const network = state.networks.items[id];

  if (!network) return undefined;

  return network;
});

export default combineReducers({ items });
